import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/system';

import useImageSize from '../../hooks/useImageSize';
import { HAIRLINE, MUTED, TEXT_DARK } from '../common/tokens';

/**
 * A cover image suggestion's value: thumbnail, URL, and the image's pixel size —
 * measured in the browser, since a page's metadata rarely states it.
 */
export default function CoverCandidateValue({ candidate }) {
  const size = useImageSize(candidate.value);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '9px' }}>
      <Box
        component="img"
        src={candidate.value}
        alt=""
        sx={{
          width: 64,
          height: 44,
          objectFit: 'cover',
          borderRadius: '4px',
          flexShrink: 0,
          border: `1px solid ${HAIRLINE}`,
        }}
      />
      <Box sx={{ minWidth: 0 }}>
        <Box sx={{
          fontWeight: 600,
          fontSize: '.85rem',
          color: TEXT_DARK,
          overflowWrap: 'anywhere',
        }}>
          {candidate.value}
        </Box>
        {size && (
          <Box sx={{ fontSize: 11, color: MUTED, fontVariantNumeric: 'tabular-nums' }}>
            {`${size.width} × ${size.height}`}
          </Box>
        )}
      </Box>
    </Box>
  );
}

CoverCandidateValue.propTypes = { candidate: PropTypes.object.isRequired };
